import React, {useEffect, useState} from 'react';
import {Card, Checkbox, Flex} from "antd";
import style from "./CitiesCard.module.scss";
import {StyledCard} from "./CitiesCard.styled";
import { FaChevronLeft } from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {CitiesCardProps, ProvinceCardProps} from "../../../models";

const CitiesCard = ({title,id,onCityClick,citiesId,item} :CitiesCardProps) => {
    const navigate =useNavigate()
    const [isChecked, setIsChecked] = useState<boolean>(false)
    useEffect(() => {
        setIsChecked(citiesId.some((i:any) => i.id === item.id))
    }, [citiesId]);
    return (
        <StyledCard  >
            <Flex justify={"space-between"} align={"center"}>
                <span> {title} </span>
                <Checkbox checked={isChecked}
                          onClick={(value:any) => {
                              const checked = value.target.checked
                              onCityClick({item, checked})
                          }}/>

            </Flex>
        </StyledCard>
    )

};

export default CitiesCard;
